import { Create } from './components/Create';
import { Edit } from './components/Edit';
import { Intro } from './components/Intro';
import { IssuePrompt } from './components/IssuePrompt';
import { Location } from './components/Location';
import { Media } from './components/Media';
import { OptionalPreview } from './components/OptionalPreview';
import { PersonalPrompt } from './components/PersonalPrompt';
import { PrePublish } from './components/PrePublish';
import { Preview } from './components/Preview';
import { Recommendations } from './components/Recommendations';
import { usePageBody } from './hooks/usePageBody';

export function PageBody() {
	const { actions } = usePageBody();

	// eslint-disable-next-line complexity
	const Component = (() => {
		switch (true) {
			case actions.matches('idle'):
				return null;
			case actions.matches('intro'):
				return <Intro />;
			case actions.matches('issue'):
				return <IssuePrompt />;
			case actions.matches('personal-story'):
				return <PersonalPrompt />;
			case actions.matches('recommendations'):
				return <Recommendations />;
			case actions.matches('optional-preview'):
				return <OptionalPreview />;
			case actions.matches('preview'):
				return <Preview />;
			case actions.matches('create'):
				return <Create />;
			case actions.matches('edit'):
				return <Edit />;
			case actions.matches('location'):
				return <Location />;
			case actions.matches('media'):
				return <Media />;
			case actions.matches('prepublish'):
				return <PrePublish />;
			default:
				// probably throw an error here and handle in error boundary?
				return <div>unknown state</div>;
		}
	})();

	return Component;
}
